import {
  IconAlertTriangle,
  IconBook2,
  IconBrain,
  IconChartBar,
  IconCode,
  IconSearch,
  IconArrowLeft,
  IconArrowRight,
  IconPlus,
  IconRefresh,
  IconBell,
  IconCheck,
  IconChevronDown,
  IconChevronUp,
  IconCircleCheck,
  IconClock,
  IconCoin,
  IconEye,
  IconEyeOff,
  IconHome2,
  IconInbox,
  IconLayoutDashboard,
  IconLayoutSidebar,
  IconLink,
  IconLogout,
  IconFile,
  IconHeart,
  IconHeartFilled,
  IconMessageCircle,
  IconMovie,
  IconMusic,
  IconPaperclip,
  IconPhoto,
  IconPalette,
  IconSend,
  IconPlayerPlay,
  IconPlayerStop,
  IconCalendar,
  IconListCheck,
  IconPencil,
  IconBrandYoutube,
  IconSettings,
  IconShieldCheck,
  IconAdjustmentsHorizontal,
  IconArrowUp,
  IconArrowsDiagonal,
  IconDots,
  IconLayoutSidebarRightCollapse,
  IconMessageCircleQuestion,
  IconUser,
  IconUserCircle,
  IconRobot,
  IconUsersGroup,
  IconVolume,
  IconVolumeOff,
  IconX,
  IconTool,
  type IconProps,
} from "@tabler/icons-react";

// The owner rail retains the production line icon family. Plugin page names
// use the same semantic vocabulary; unknown declarations use the rail glyph.
const icons = {
  back: IconArrowLeft,
  arrow: IconArrowRight,
  plus: IconPlus,
  refresh: IconRefresh,
  today: IconHome2,
  identity: IconUserCircle,
  content: IconMovie,
  channels: IconLink,
  waiting: IconBell,
  yes: IconCheck,
  no: IconX,
  up: IconChevronUp,
  down: IconChevronDown,
  clock: IconClock,
  shield: IconShieldCheck,
  money: IconCoin,
  person: IconUser,
  agent: IconRobot,
  people: IconUsersGroup,
  send: IconSend,
  play: IconPlayerPlay,
  stop: IconPlayerStop,
  // A film's sound, on and off.
  volume: IconVolume,
  muted: IconVolumeOff,
  // A viewer's like on a Square work, not given and given.
  like: IconHeart,
  liked: IconHeartFilled,
  calendar: IconCalendar,
  clapperboard: IconMovie,
  // The three an attachment card draws from (`components/attachments`).
  picture: IconPhoto,
  sound: IconMusic,
  file: IconFile,
  // Giving the Agent a file from the input bar (`shell/Composer.tsx`).
  attach: IconPaperclip,
  "list-check": IconListCheck,
  "pencil-ruler": IconPencil,
  youtube: IconBrandYoutube,
  eye: IconEye,
  "eye-off": IconEyeOff,
  tool: IconTool,
  alert: IconAlertTriangle,
  done: IconCircleCheck,
  developer: IconAdjustmentsHorizontal,
  look: IconEye,
  wall: IconLayoutDashboard,
  chat: IconMessageCircle,
  settings: IconSettings,
  // One glyph per kind of IP 设置 (`connections/directory.ts`), and the magnifier a search box wears.
  brain: IconBrain,
  memory: IconBook2,
  chart: IconChartBar,
  code: IconCode,
  search: IconSearch,
  theme: IconPalette,
  studio: IconLayoutSidebar,
  // The sidebar's 待我回应 and the account menu's 退出登录.
  inbox: IconInbox,
  logout: IconLogout,
  // The Agent's bar and the conversation beside it.
  more: IconDots,
  expand: IconArrowsDiagonal,
  collapse: IconLayoutSidebarRightCollapse,
  "arrow-up": IconArrowUp,
  question: IconMessageCircleQuestion,
  edit: IconPencil,
} as const;

export type IconName = keyof typeof icons;

/** Declared glyph names use the installed icon set, independent of plugin keys. */
export function declaredIcon(value: unknown, fallback: IconName = "studio"): IconName {
  return typeof value === "string" && Object.hasOwn(icons, value) ? value as IconName : fallback;
}

export function Icon({
  name,
  size = 18,
  ...props
}: { name: IconName } & IconProps) {
  const Glyph = icons[name];
  return (
    <Glyph
      size={size}
      stroke={1.75}
      aria-hidden="true"
      data-icon={name}
      focusable="false"
      className="icon"
      {...props}
    />
  );
}
